import {
  DetailAlbumDto,
  ListAlbumDto,
  TrackAlbumDto,
} from "@/lib/lutely-api/gen/dtos";
import { Link, LinkProps } from "@tanstack/react-router";

/** TrackAlbumDto carries no slugs, so those albums fall back to the id route. */
export type LinkableAlbum = ListAlbumDto | DetailAlbumDto | TrackAlbumDto;

interface Props extends LinkProps {
  album: LinkableAlbum;
  children?: React.ReactNode;
  className?: string;
  /** Point at the creator's album management page instead of the storefront. */
  audiolab?: boolean;
}

export const AlbumLink = ({
  album,
  children,
  className,
  audiolab,
  ...rest
}: Props) => {
  const albumSlug = "slug" in album ? album.slug : null;
  const creatorSlug = "creator" in album ? album.creator.slug : null;

  if (audiolab) {
    return (
      <Link
        className={className}
        {...rest}
        to={`/audiolab/releases/$ALBUM_ID`}
        params={{ ALBUM_ID: album.albumId }}
      >
        {children}
      </Link>
    );
  }

  if (albumSlug && creatorSlug) {
    return (
      <Link
        className={className}
        {...rest}
        to={`/@{$CREATOR_SLUG}/$ALBUM_SLUG`}
        params={{ CREATOR_SLUG: creatorSlug, ALBUM_SLUG: albumSlug }}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      className={className}
      {...rest}
      to={`/albums/$ALBUM_ID`}
      params={{ ALBUM_ID: album.albumId }}
    >
      {children}
    </Link>
  );
};
